// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__l+hQa","faqs":"Faq_faqs__Cw5kg","zoomInOut":"Faq_zoomInOut__yjvnF"};